<template>
  <card type="white" headerClasses="pt-1 pb-2 px-2" bodyClasses="px-1 py-0">
    <div slot="header">
      <div class="col-12 text-left">
        <h5 class="h3 mb-0">
          {{ title }}
        </h5>
        <h6 class="text-muted text-uppercase ls-1 mb-1">
          {{ subtitle }}
        </h6>
      </div>
    </div>
    <apexchart
      :height="height"
      :options="chartOptions"
      :series="chartSeries"
    ></apexchart>
  </card>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    subtitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      default: 300,
    },
    rawData: {
      type: Array,
      default: () => [],
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      chartOptions: {
        legend: {
          position: "bottom",
        },
        chart: {
          type: "line",
          toolbar: {
            show: true,
            zoom: {
              enabled: true,
            },
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
            autoSelected: "zoom",
          },
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          forceNiceScale: true,
          labels: {
            formatter: function (val) {
              return Math.round(val * 100) / 100;
            },
          },
        },
      },
      chartSeries: [],
    };
  },
  mounted() {
    this.formatLineChartData(this.rawData, this.label || this.title);
  },
  watch: {
    rawData() {
      this.formatLineChartData(this.rawData, this.label || this.title);
    },
  },
  methods: {
    formatLineChartData(points, label) {
      const series = {
        name: label,
        data: [],
      };
      const xaxis = {
        categories: [],
      };
      points.forEach((point) => {
        series.data.push(point.value);
        xaxis.categories.push(
          this.moment(point.date, "YYYY-MM-DD")
            .subtract(1, "months")
            .format("MMM")
        );
      });
      this.chartSeries = [series];
      this.chartOptions = { ...this.chartOptions, ...{ xaxis: xaxis } };
    },
  },
};
</script>
